import { Redirect } from 'expo-router';

import { routes } from '@fhs-legacy/frontend/src/utils/routing';

export default function OffersLayout() {
  return <Redirect href={routes.offersV2} />;
}
